import List from '@mui/material/List';
import { ReportItem } from '../ReportItem';
import {
  Typography,
} from '@mui/material';
import { ReportType } from '../ReportItem/types';

const ReportsList = ({reports}:{reports:any[]}) => {
  return reports.length > 0 ? (
    <List disablePadding sx={{ mb: 1 }}>
      {reports.slice(0, 2).map((item, index) => (
        <ReportItem item={item} key={index} />
      ))}
    </List>
  ) : (
    <Typography
        fontSize={'13px'}
        variant={'body1'}
        color={'text.secondary'}
        sx={{display: 'flex', alignItems: 'center', justifyContent: 'center',height: '100%'}}
    >
        No Reports found
    </Typography>
  );;
};

export { ReportsList };
